import { getNormalizedServerParameterDate } from '@hungryroot/datetime';
import { log } from '@hungryroot/o11y';

/**
 * Receives an order object and returns the inventory date.
 *
 * If the inventory date is provided, it will return that
 * otherwise it will use the cutoff date to calculate the inventory date.
 */
export function getInventoryDate({
  id,
  cutoff_datetime,
  inventory_date,
}: {
  id: number;
  cutoff_datetime: string;
  inventory_date: string | null;
}) {
  if (!inventory_date) {
    log('No `inventory_date` provided in getInventoryDate.', {
      cutoff_datetime,
      inventory_date,
      orderId: id,
    });
  }

  return inventory_date
    ? inventory_date
    : getNormalizedServerParameterDate(cutoff_datetime);
}
